export default __webpack_public_path__ + "static/media/builtClimbingTimer.39f20f06.png";